
<div class="wrapper">
  <a class="hidden-below-sm" data-pm-id="gh-logo" routerLink="/">
    <span class="pmcc-nav-item logo pmcc-d-sm-none pmcc-d-md-inline-block"></span>
  </a>
  <div *ngIf = "!logoutPage" class="nav-items-wrapper">
    <span class="pmcc-nav-item" *ngFor="let menuItem of menuConfig" [class.selected]="menuItem.id==currentMenuId">
        <a
          [routerLink]="menuItem.routerLink"
          (click)="currentMenuId=menuItem.id"
        >
          <label [attr.data-pm-id]="menuItem.label">{{menuItem.label}}</label>
        </a>
    </span>
    <span class="pmcc-nav-item force-right"></span>
  </div>
  <div *ngIf = "!logoutPage" class="user-menu-wrapper">
    <span class="pmcc-nav-item tight stacked hidden-below-lg last" data-pm-id="gh-user-info">
      <div class="logged-user-heading">{{userInfo ? userInfo.username : ''}}</div>
        <span> <a class="small" (click)="logout()">Logout</a></span>
    </span>
  </div>
</div>
